import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingEngineerForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="engineer"
      settingKey="engineer_role_setting"
    />
  );
}

export default SpacesSettingEngineerForm;
